const routes = {
    home: '/',
    homePhone: '/home',
    explore: '/explore',
    following: '/following',
    myprofile: '/myprofile',
    profile: '/:username',
    search: '/search/user/:value',
    upload: '/upload',
    live: '/live',
};

export default routes;
